module.exports = __webpack_public_path__ + "img/DE00368.6d0df422.png";